// FilterButtons: a row of 32px text buttons; the selected one gets a subtle lime tint + lime text (DESIGN §2).
import './compact-dropdown.css';
// options: strings or [{ value, label, count? }]. onChange(value). Arrow keys move the selection.
// variant: 'bordered' (default; filters) | 'text' (borderless time-scale controls: chart ranges, calendar views).
import { cx } from './ui.jsx';

const toOption = (o) => (typeof o === 'object' && o !== null ? o : { value: o, label: String(o) });

export function FilterButtons({ options = [], value, onChange, label = 'Filter', size, variant, class: cls }) {
  const opts = options.map(toOption);
  const selected = opts.findIndex((o) => o.value === value);
  const onKeyDown = (e) => {
    const n = opts.length;
    const i = Math.max(0, selected);
    const next = { ArrowRight: (i + 1) % n, ArrowLeft: (i - 1 + n) % n, Home: 0, End: n - 1 }[e.key];
    if (next === undefined || !n) return;
    e.preventDefault();
    onChange?.(opts[next].value);
    e.currentTarget.querySelectorAll('button')[next]?.focus();
  };
  return (
    <div class={cx('filter-buttons', size === 'sm' && 'filter-buttons-sm', variant === 'text' && 'filter-buttons-text', cls)} role="radiogroup" aria-label={label} onKeyDown={onKeyDown}>
      {opts.map((o, i) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          class="filter-btn"
          aria-checked={i === selected ? 'true' : 'false'}
          tabIndex={i === selected || (selected < 0 && i === 0) ? 0 : -1}
          onClick={() => onChange?.(o.value)}
        >
          {o.label}
          {o.count != null && <span class="filter-count">{o.count}</span>}
        </button>
      ))}
    </div>
  );
}
